import type { DialogModal, NotifyModal } from '@shared/types/common';

import { openDialogModal, openNotifyModal } from '@src/library/redux/modal';

import { useAppDispatch } from './use-app-dispatch';

export const useDialog = () => {
	const dispatch = useAppDispatch();

	const notification = (notification: NotifyModal) => dispatch(openNotifyModal(notification));

	const dialog = (dialog: DialogModal) => dispatch(openDialogModal(dialog));

	return {
		dialog,
		notification,
	};
};
